import { Permission } from "@bonusmap/api-types";
import { DataBaseComponent } from "./data-base-component.js";

export class DataPermissionComponent extends DataBaseComponent {
    static webComponentName: string = "data-permission";
    protected _templateId: string = "data-permission-template"; // Template ID for rendering
    protected inputType: string = "text"; // Default input type for string fields
    
    constructor() {
        super();
    }
    addDataForTemplate(): Record<string, any> {
        const permissionsList:Permission[] = window.permissionsList || [];
        const currentPermission = this.value ? permissionsList.find(p=>p.id===this.value) : null;
        return {
            currentPermission,
            permissionsList
        };
    }

}
